module.exports = __webpack_public_path__ + "img/markerIconWhite.7ea423e1.svg";